import { Checkbox, Col, Row } from "antd";
import { useStyles } from "../personInfoModal";
import { VerticalSpace } from "@app/UI/VerticalSpace";

export const MembersBlock = ({ register, personW, setValue }) => {
  const classes = useStyles();

  return (
    <Row gutter={16} className={classes.block}>
      <Col>
        <VerticalSpace>
          <Checkbox
            {...register("personRole.isSupervisoryBoardMember")}
            checked={personW?.personRole?.isSupervisoryBoardMember}
            onChange={(e) => setValue("personRole.isSupervisoryBoardMember", e.target.checked)}
          >
            Член наблюдательного совета
          </Checkbox>
          <Checkbox
            {...register("personRole.isCollegialExecutiveBodyMember")}
            checked={personW?.personRole?.isCollegialExecutiveBodyMember}
            onChange={(e) =>
              setValue("personRole.isCollegialExecutiveBodyMember", e.target.checked)
            }
          >
            Член коллегиального исполнительного органа
          </Checkbox>
        </VerticalSpace>
      </Col>
    </Row>
  );
};
